<template>
  <div class="documentation">
      <resource></resource>
  </div>
</template>

<script>
import resource from "./Resource";

export default {
  data: function() {
    return {};
  },
  components:{
      resource
  }
};
</script>

<style scoped></style>
